import axiosClient from "./axiosClient";

const createEmail = (param) => {
  const url = "/email";
  return axiosClient.post(url, param);
};

const saveTemplate = (param) => {
  const url = "/email/template";
  return axiosClient.post(url, param);
};

const deleteTemplate = (id) => {
  const url = `/email/template/${id}`;
  return axiosClient.delete(url);
};

const getTemplateList = ({ sortBy = "createdAt:ASC", page = 1, limit = 20, type = "all" } = {}) => {
  const params = new URLSearchParams({
    sortBy,
    page,
    limit,
    type,
  });
  const url = `/email/template?${params.toString()}`;
  return axiosClient.get(url);
};

const getTemplateById = (id) => {
  const url = `/email/template/${id}`;
  return axiosClient.get(url);
};

const getSendingStatus = (companyId) => {
  const q = new URLSearchParams();
  if (companyId) {
    q.set("companyId", companyId);
  }
  const url = `/email/sendingStatus?${q.toString()}`;
  return axiosClient.get(url);
};

const toggleSendingPaused = (companyId, paused) => {
  const url = "/email/toggleSendingPaused";
  return axiosClient.post(url, { companyId, paused });
};

export {
  createEmail,
  saveTemplate,
  getTemplateList,
  getTemplateById,
  deleteTemplate,
  getSendingStatus,
  toggleSendingPaused,
};
